import axios from '../../../axios';

export type ServiceResponse = {
  id: string;
  plateNumber: string;
  createDate: string;
  entryStation: string;
  exitStation: string;
  entryDate: string;
  exitDate: string;
  amount: number;
  invoiceNo: string;
};

export default async function getSecondHandRepository(): Promise<ServiceResponse[]> {
  const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/fleet/second-hand`);
  return res.data;
}
